import { SmartSubscribe } from '@dinosband/bv-main-client'
import { queryLastMessages, subscribeMessages } from '@dinosband/bv-messenger-client'
import { Message } from '@dinosband/bv-messenger-schema'
import { BvDataCenterContext } from '..'
import { BvSubscriber } from './manager/subscriber'

export class MessageSubscriber extends BvSubscriber<Message> {

  context: BvDataCenterContext
  chatRoomIds: number[]

  constructor (context: BvDataCenterContext, chatRoomIds: number[], callback: (value: Message | Message[]) => void) {
    super(callback)
    this.context = context
    this.chatRoomIds = chatRoomIds
  }

  protected async query () {
    return await queryLastMessages(await this.context.messengerClient.getClient(), this.chatRoomIds)
  }

  protected async subscribe () {
    const subscription = subscribeMessages(await this.context.messengerClient.getClient(), this.chatRoomIds).subscribe({
      next: async (value) => {
        if (value.data?.message) {
          this.callback(value.data.message)
        }
      },
      error: console.error,
    })
    return subscription as unknown as SmartSubscribe
  }

}

